import React, { useState } from "react";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import classes from "./questionnaire.module.css";

const GOOGLE_FORM_ACTION =
    "https://docs.google.com/forms/d/e/1FAIpQLSeYIabTyCGSOHldHE_CrbgX3qDKbjzU8euW3gb5yG765gCHYQ/formResponse";

const GOOGLE_FORM_LINK = "https://forms.gle/mbPvCnVdxECdMSwf6";
const RESULTS_PAGE_LINK = "/results";

const FIELD_IDS = {
    email: "entry.1412481037",
    q1: "entry.1309770283",
    q2: "entry.1449590649",
    q3: "entry.1451088487",
    q4: "entry.1201924683",
    q5: "entry.1329816303",
    q6: "entry.1767645503",
    q7: "entry.521427938",
    q8: "entry.2106180301",
    q9: "entry.1374919058",
    q10: "entry.1094223737",
    profile: "entry.1037739192",
};

const questions = [
    {
        key: "q1",
        title:
            "Интересно ли вам узнать, какие возможности даёт цифровизация бизнес-процессов во взаимодействии между потребителем и контролирующей организацией? / Сізге тұтынушы мен бақылаушы ұйым арасындағы өзара әрекеттестікте бизнес-процестерді цифрландыру қандай мүмкіндіктер беретінін білу қызықты ма?",
        options: [
            "Да, хочу понять, как цифровизация улучшает взаимодействие между потребителем и контролирующей организацией. / Иә, цифрландыру тұтынушы мен бақылаушы ұйым арасындағы өзара әрекеттестікті қалай жақсартатынын түсінгім келеді.",
            "Интересно узнать, какие процессы можно автоматизировать с её помощью. / Оның көмегімен қандай процестерді автоматтандыруға болатынын білгім келеді.",
            "Полезно понять, как это повышает прозрачность, скорость обмена информацией и качество принятия решений. / Бұл ақпарат алмасудың ашықтығын, жылдамдығын және шешім қабылдау сапасын қалай арттыратынын түсіну пайдалы.",
            "Иное",
        ],
    },
    {
        key: "q2",
        title:
            "Интересно ли вам узнать о подходах цифровизации, которые помогают принимать обоснованные решения по количественной оценке водных ресурсов? / Сізге су ресурстарының сандық бағасын жүргізуге мүмкіндік беретін цифрландыру тәсілдері туралы білу қызықты ма?",
        options: [
            "Да, хочу понять, какие цифровые инструменты используются для количественной оценки водных ресурсов. / Иә, су ресурстарының көлемін сандық бағалау үшін қандай цифрлық құралдар қолданылатынын түсінгім келеді.",
            "Интересно узнать, как цифровизация способствует формированию управленческих решений в сфере водных ресурсов. / Цифрландыру су ресурстары саласында басқарушылық шешімдер қабылдауға қалай ықпал ететінін білгім келеді.",
            "Полезно понять, как цифровые инструменты повышают обоснованность управленческих решений. / Цифрлық құралдар басқарушылық шешімдердің негізділігін қалай арттыратынын түсіну пайдалы.",
            "Иное",
        ],
    },
    {
        key: "q3",
        title:
            "Интересно ли вам разобраться, какие современные методы измерения расхода воды позволяют получать более точные и надёжные данные? / Су шығынын өлшеудің заманауи әдістері неғұрлым дәл және сенімді деректер алуға қалай мүмкіндік беретінін түсіну сізге қызықты ма?",
        options: [
            "Хочу понять различия между методами измерения. / Өлшеу әдістерінің айырмашылықтарын түсінгім келеді.",
            "Интересно узнать об акустических и скоростных методах. / Акустикалық және жылдамдық әдістері туралы білгім келеді.",
            "Полезно понять, как выбрать метод для точных расчётов. / Дәл есептеулер үшін әдісті қалай таңдау керектігін түсіну пайдалы.",
            "Иное",
        ],
    },
    {
        key: "q4",
        title:
            "Интересно ли вам узнать, как современные системы мониторинга и автоматического регулирования помогают эффективно управлять уровнем и расходом воды на гидротехнических сооружениях? / Заманауи мониторинг және автоматты реттеу жүйелері гидротехникалық құрылымдарда су деңгейі мен шығынын тиімді басқаруға қалай көмектесетінін білу сізге қызықты ма?",
        options: [
            "Хочу понять, какие данные необходимы для принятия решений. / Шешім қабылдау үшін қандай деректер қажет екенін түсінгім келеді.",
            "Интересно узнать, как работает автоматическое регулирование в режиме реального времени. / Нақты уақыт режимінде автоматты реттеу қалай жұмыс істейтінін білгім келеді.",
            "Полезно понять, как это повышает надёжность эксплуатации сооружений. / Бұл құрылыстарды пайдалану сенімділігін қалай арттыратынын түсіну пайдалы.",
            "Иное",
        ],
    },
    {
        key: "q5",
        title:
            "Интересно ли вам разобраться, как математические модели используются для анализа и прогнозирования состояния водных ресурсов? / Математикалық модельдер су ресурстарының жағдайын талдау және болжау үшін қалай қолданылатынын түсіну сізге қызықты ма?",
        options: [
            "Хочу понять, какие данные используются и как учитывается неопределённость. / Қандай деректер қолданылатынын және белгісіздік қалай ескерілетінін түсінгім келеді.",
            "Интересно узнать, как моделирование выявляет тенденции и риски. / Модельдеу үрдістер мен тәуекелдерді қалай анықтайтынын білгім келеді.",
            "Полезно понять, как результаты моделей помогают управлять ресурсами. / Модель нәтижелерінің ресурстарды басқаруға қалай көмектесетінін түсіну пайдалы.",
            "Иное",
        ],
    },
    {
        key: "q6",
        title:
            "Интересно ли вам разобраться, как можно заранее оценивать возможные изменения водообеспеченности региона при различных сценариях? / Әртүрлі сценарийлер жағдайында өңірдің сумен қамтамасыз етілуіндегі ықтимал өзгерістерді алдын ала бағалау жолдарын түсіну сізге қызықты ма?",
        options: [
            "Хочу понять, какие факторы влияют на водообеспеченность. / Өңірдің сумен қамтамасыз етілуіне қандай факторлар әсер ететінін түсінгім келеді.",
            "Интересно узнать, как сравниваются различные сценарии развития ситуации. / Жағдай дамуының әртүрлі сценарийлері қалай салыстырылатынын білгім келеді.",
            "Полезно понять, как результаты сценарного анализа помогают принимать долгосрочные решения. / Сценарийлік талдау нәтижелерінің ұзақ мерзімді шешімдер қабылдауға қалай көмектесетінін түсіну пайдалы.",
            "Иное",
        ],
    },
    {
        key: "q7",
        title:
            "Полезно ли вам разобраться, как сценарное моделирование помогает управлять водными ресурсами? / Сценарийлік модельдеудің су ресурстарын басқаруға қалай көмектесетінін түсіну сізге пайдалы ма?",
        options: [
            "Хочу понять, как моделирование выявляет риски дефицита воды. / Модельдеу су тапшылығы тәуекелдерін қалай анықтайтынын түсінгім келеді.",
            "Интересно узнать, как формируются сценарии распределения ресурсов. / Ресурстарды бөлу сценарийлері қалай құрылатынын білгім келеді.",
            "Полезно понять, как прогнозные расчёты корректируют планы водопользования. / Болжамдық есептеулер су пайдалану жоспарларын қалай түзететінін түсіну пайдалы.",
            "Иное",
        ],
    },
    {
        key: "q8",
        title:
            "Интересно ли вам разобраться, как современные измерительные комплексы и автоматизированные механизмы регулирования помогают эффективно управлять подачей и распределением воды? / Заманауи өлшеу кешендері мен автоматтандырылған реттеу тетіктері суды беру және бөлу процесін тиімді басқаруға қалай көмектесетінін түсіну сізге қызықты ма?",
        options: [
            "Хочу понять, какие параметры контролируются. / Қандай параметрлер бақыланатынын түсінгім келеді.",
            "Интересно узнать, как автоматизация позволяет оперативно реагировать на изменения. / Автоматтандыру өзгерістерге жедел әрекет етуге қалай мүмкіндік беретінін білгім келеді.",
            "Полезно понять, как это повышает устойчивость водораспределительной инфраструктуры. / Бұл су тарату инфрақұрылымының орнықтылығын қалай арттыратынын түсіну пайдалы.",
            "Иное",
        ],
    },
    {
        key: "q9",
        title:
            "Интересно ли вам разобраться, как интеграция данных из разных источников помогает формировать целостную картину состояния водных ресурсов региона? / Әртүрлі көздерден алынған деректерді біріктіру өңірдің су ресурстары жағдайының толық көрінісін қалыптастыруға қалай көмектесетінін түсіну сізге қызықты ма?",
        options: [
            "Хочу понять, как объединяются данные гидропостов, метеонаблюдений и полевых измерений. / Гидрологиялық бекеттер, метеобақылаулар және далалық өлшеулер деректері қалай біріктірілетінін түсінгім келеді.",
            "Интересно узнать, как анализируются пространственно-временные изменения. / Кеңістіктік-уақыттық өзгерістер қалай талданатынын білгім келеді.",
            "Полезно понять, как комплексный анализ повышает точность принимаемых решений. / Кешенді талдаудың қабылданған шешімдердің дәлдігін қалай арттыратынын түсіну пайдалы.",
            "Иное",
        ],
    },
    {
        key: "q10",
        title:
            "Интересно ли вам узнать, какие программные решения и алгоритмы помогают оценивать эффективность распределения воды между различными потребителями? / Әртүрлі тұтынушылар арасында суды бөлудің тиімділігін бағалауға қандай бағдарламалық қамтамасыз ету құралдары мен алгоритмдер көмектесетінін білу сізге қызықты ма?",
        options: [
            "Хочу понять, какие программные решения и алгоритмы применяются для анализа распределения воды между потребителями. / Су таратудағы үлесті талдау үшін қандай бағдарламалық шешімдер мен алгоритмдер қолданылатынын түсінгім келеді.",
            "Интересно узнать, какие критерии и метрики используются для оценки эффективности распределения. / Бөлу тиімділігін бағалау үшін қандай критерийлер мен метрикалар қолданылатынын білгім келеді.",
            "Полезно понять, как аналитические инструменты помогают выявлять дисбаланс и оптимизировать распределение ресурсов. / Аналитикалық құралдар дисбалансты анықтауға және ресурстарды оңтайландыруға қалай көмектесетінін түсіну пайдалы.",
            "Иное",
        ],
    },
];

const profileOptions = [
    "Производственный инженер/Өндіріс инженері",
    "Молодой специалист/Жас маман",
    "Исследователь/Зерттеуші",
    "Иное",
];

const initialOther = {
    q1: "", q2: "", q3: "", q4: "", q5: "",
    q6: "", q7: "", q8: "", q9: "", q10: "",
    profile: "",
};

const initialAnswers = {
    q1: "", q2: "", q3: "", q4: "", q5: "",
    q6: "", q7: "", q8: "", q9: "", q10: "",
};

function ActionButtons() {
    return (
        <div className={classes.buttons}>
            <a
                href={GOOGLE_FORM_LINK}
                target="_blank"
                rel="noreferrer"
                className={classes.pillButton}
            >
                Пройти опросник в google формах
            </a>
            <a href={RESULTS_PAGE_LINK} className={classes.pillButton}>
                Результаты опросника
            </a>
        </div>
    );
}

const QuestionnairePage = () => {
    const [formData, setFormData] = useState({
        email: "",
        answers: { ...initialAnswers },
        profile: [],
        otherText: { ...initialOther },
    });

    const [submitting, setSubmitting] = useState(false);
    const [success, setSuccess] = useState(false);

    const handleAnswerChange = (key, value) => {
        setFormData((prev) => ({
            ...prev,
            answers: { ...prev.answers, [key]: value },
        }));
    };

    const handleOtherChange = (key, value) => {
        setFormData((prev) => ({
            ...prev,
            otherText: { ...prev.otherText, [key]: value },
        }));
    };

    const handleProfileChange = (value) => {
        setFormData((prev) => {
            const exists = prev.profile.includes(value);
            return {
                ...prev,
                profile: exists
                    ? prev.profile.filter((item) => item !== value)
                    : [...prev.profile, value],
            };
        });
    };

    const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());

    const validateForm = () => {
        if (!formData.email.trim()) {
            alert("Пожалуйста, укажите email.");
            return false;
        }
        if (!validateEmail(formData.email)) {
            alert("Введите корректный email.");
            return false;
        }
        for (const question of questions) {
            const value = formData.answers[question.key];
            if (!value) {
                alert("Пожалуйста, ответьте на все вопросы.");
                return false;
            }
            if (value === "Иное" && !formData.otherText[question.key].trim()) {
                alert("Пожалуйста, заполните поле «Иное».");
                return false;
            }
        }
        if (!formData.profile.length) {
            alert("Пожалуйста, выберите профиль деятельности.");
            return false;
        }
        if (
            formData.profile.includes("Иное") &&
            !formData.otherText.profile.trim()
        ) {
            alert("Пожалуйста, заполните поле «Иное» для профиля деятельности.");
            return false;
        }
        return true;
    };

    const resetForm = () => {
        setFormData({
            email: "",
            answers: { ...initialAnswers },
            profile: [],
            otherText: { ...initialOther },
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setSubmitting(true);
        setSuccess(false);

        try {
            const payload = new FormData();
            payload.append(FIELD_IDS.email, formData.email.trim());

            questions.forEach((question) => {
                const selected = formData.answers[question.key];
                if (selected === "Иное") {
                    payload.append(FIELD_IDS[question.key], "__other_option__");
                    payload.append(
                        `${FIELD_IDS[question.key]}.other_option_response`,
                        formData.otherText[question.key].trim()
                    );
                } else {
                    payload.append(FIELD_IDS[question.key], selected);
                }
            });

            formData.profile.forEach((item) => {
                if (item === "Иное") {
                    payload.append(FIELD_IDS.profile, "__other_option__");
                    payload.append(
                        `${FIELD_IDS.profile}.other_option_response`,
                        formData.otherText.profile.trim()
                    );
                } else {
                    payload.append(FIELD_IDS.profile, item);
                }
            });

            await fetch(GOOGLE_FORM_ACTION, {
                method: "POST",
                mode: "no-cors",
                body: payload,
            });

            setSuccess(true);
            resetForm();
            window.scrollTo({ top: 0, behavior: "smooth" });
        } catch (error) {
            console.error(error);
            alert("Ошибка при отправке формы.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div>
            <Header />
            <div className={classes.wrapper}>
                <div className={classes.container}>
                    <div className={classes.card}>
                        <span className={classes.badge}>Опросник</span>
                        <h1 className={classes.title}>Оценка интереса к тематике семинаров</h1>

                        <ActionButtons />

                        <div className={classes.intro}>
                            Уважаемые коллеги!
                            {"\n\n"}
                            Мы планируем проведение учебных семинаров и обучающих мероприятий для сотрудников и хотим сделать их максимально полезными и практичными.
                            {"\n"}
                            Этот опрос поможет понять:
                            {"\n"}
                            - каких знаний и навыков вам не хватает в повседневной работе;
                            {"\n"}
                            - с какими трудностями вы сталкиваетесь при сборе, анализе и использовании информации;
                            {"\n"}
                            - какие темы обучения и форматы семинаров будут для вас наиболее актуальны.
                            {"\n\n"}
                            Опрос анонимный. Все ответы будут рассмотрены в обобщённом виде и использованы только для формирования программы будущих семинаров. Пожалуйста, отвечайте, исходя из вашего реального рабочего опыта. Ваше мнение напрямую повлияет на содержание обучения.
                            {"\n\n"}
                            Спасибо за участие!
                            {"\n\n"}
                            Құрметті әріптестер!
                            {"\n\n"}
                            Біз қызметкерлерге арналған оқу семинарлары мен біліктілікті арттыру іс-шараларын жоспарлап отырмыз. Бұл сауалнама сол семинарларды шын мәнінде пайдалы және практикалық ету мақсатында жүргізіледі.
                            {"\n"}
                            Сауалнама арқылы:
                            {"\n"}
                            - күнделікті жұмысыңызда қандай білім мен дағдылар жетіспейтінін;
                            {"\n"}
                            - ақпаратты жинау, өңдеу және пайдалану кезінде қандай қиындықтар кездесетінін;
                            {"\n"}
                            - қандай тақырыптар бойынша оқу семинарлары қажет екенін анықтағымыз келеді.
                            {"\n\n"}
                            Сауалнама анонимді. Барлық жауаптар жалпыланған түрде ғана талданып, болашақ оқу семинарларының бағдарламасын қалыптастыру үшін пайдаланылады. Сұрақтарға өз жұмыс тәжірибеңізге сүйене отырып жауап беруіңізді сұраймыз. Сіздің пікіріңіз оқу мазмұнын жақсартуға тікелей әсер етеді.
                            {"\n\n"}
                            Қатысқаныңыз үшін рахмет!
                        </div>

                        {success && (
                            <div className={classes.success}>
                                Спасибо! Ответ успешно отправлен.
                            </div>
                        )}

                        <form className={classes.form} onSubmit={handleSubmit}>
                            <div className={classes.block}>
                                <h3 className={classes.blockTitle}>
                                    Электронный адрес/Электрондық поштаның адресі
                                </h3>
                                <input
                                    type="email"
                                    className={classes.input}
                                    placeholder="example@mail.com"
                                    value={formData.email}
                                    onChange={(e) =>
                                        setFormData((prev) => ({ ...prev, email: e.target.value }))
                                    }
                                />
                            </div>

                            {questions.map((question) => (
                                <div className={classes.block} key={question.key}>
                                    <h3 className={classes.blockTitle}>{question.title}</h3>
                                    <div className={classes.optionsList}>
                                        {question.options.map((option) => {
                                            const checked = formData.answers[question.key] === option;
                                            const isOther = option === "Иное";
                                            return (
                                                <div key={option}>
                                                    <label className={classes.optionCard}>
                                                        <input
                                                            type="radio"
                                                            name={question.key}
                                                            value={option}
                                                            checked={checked}
                                                            onChange={() =>
                                                                handleAnswerChange(question.key, option)
                                                            }
                                                        />
                                                        <span>{option}</span>
                                                    </label>
                                                    {isOther && checked && (
                                                        <input
                                                            type="text"
                                                            className={`${classes.input} ${classes.otherInput}`}
                                                            placeholder="Введите свой вариант"
                                                            value={formData.otherText[question.key]}
                                                            onChange={(e) =>
                                                                handleOtherChange(question.key, e.target.value)
                                                            }
                                                        />
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            ))}

                            <div className={classes.block}>
                                <h3 className={classes.blockTitle}>
                                    Какой у вас профиль деятельности? / Жұмыс салаңыз қандай?
                                </h3>
                                <div className={classes.optionsList}>
                                    {profileOptions.map((option) => {
                                        const checked = formData.profile.includes(option);
                                        const isOther = option === "Иное";
                                        return (
                                            <div key={option}>
                                                <label className={classes.optionCard}>
                                                    <input
                                                        type="checkbox"
                                                        checked={checked}
                                                        onChange={() => handleProfileChange(option)}
                                                    />
                                                    <span>{option}</span>
                                                </label>
                                                {isOther && checked && (
                                                    <input
                                                        type="text"
                                                        className={`${classes.input} ${classes.otherInput}`}
                                                        placeholder="Введите свой вариант"
                                                        value={formData.otherText.profile}
                                                        onChange={(e) =>
                                                            handleOtherChange("profile", e.target.value)
                                                        }
                                                    />
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            <div className={classes.actions}>
                                <button
                                    type="submit"
                                    className={classes.submit}
                                    disabled={submitting}
                                >
                                    {submitting ? "Отправка..." : "Отправить"}
                                </button>
                            </div>
                        </form>

                        <ActionButtons />
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default QuestionnairePage;
